var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{attrs:{"data":_vm.data}})],1),_c('site-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }